import type { Product } from "@/components/tables/products";
import { faker } from "@faker-js/faker";

// Generate some mock data
const range = (len: number) => {
  const arr = [];
  for (let i = 0; i < len; i++) {
    arr.push(i);
  }
  return arr;
};
const generateProduct = (index: number): Product => {
  return {
    id: index + 1,
    name: faker.commerce.productName(),
    status: faker.helpers.arrayElement([
      "In Stock",
      "Out of Stock",
      "Low Stock",
    ]),
    category: faker.commerce.department(),
    sku: faker.string.uuid(),
    price: faker.commerce.price(),
    currency: faker.helpers.arrayElement(["USD", "EUR", "GBP"]),
    productDetails: range(Math.floor(Math.random() * 3)).map(() => ({
      productId: faker.string.uuid(),
      variant: faker.commerce.productAdjective(),
      unitOfMeasure: faker.helpers.arrayElement(["pcs", "kg", "g"]),
      stockQuantity: Math.floor(Math.random() * 100),
    })),
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
};
export const makeData = (len: number) => {
  return range(len).map((d): Product => {
    return {
      ...generateProduct(d),
      subRows: range(Math.floor(Math.random() * 3)).map(() =>
        generateProduct(d * 1000),
      ),
    };
  });
};
export const data = makeData(10);
